import { Box, FormHelperText, SelectChangeEvent, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { doInit2factorAuth, useAccounts, useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import { getCopierInfo } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import ButtonElement from '@/views/elements/button/ButtonElement';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import classNames from 'classnames/bind';
import { produce } from 'immer';
import { DataOnParents, KeyDataParents } from '../RegisterFollower/RegisterFollower';
import styles from './Step1.scss';
import AccountSelector from '@/views/components/componentsUI/AccountSelector';
import InputNumber from '@/views/elements/Inputs/InputNumber';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    data: any
}

type InputValueNumber = string | number | undefined

type InputValueCheckBox = boolean

type ObjectInputValue = {
    key: Field
    type: "input" | "checkbox",
    value: InputValueNumber | InputValueCheckBox
    isError: boolean
    contextError: string
}

type Field = 'value'

type DataInputValue = Record<Field, ObjectInputValue>

const Step1 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, data }: PropsStep) => {
    const { t } = useTranslation()
    const { accounts } = useAccounts()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const { Step1 }: { Step1: any } = dataOnParents

    const { dataMasterTrade } = data
    const [currentAccount, setCurrentAccount] = useState<any>(accounts?.[0]?.acctno ?? '')
    const [asset, setAsset] = useState<number>(0)
    const [valueCopied, setValueCopied] = useState<number>(0)

    const defaultValue: ObjectInputValue = {
        key: 'value',
        value: '',
        type: "input",
        isError: false,
        contextError: '',
    }

    const [inputValue, setInputValue] = useState<DataInputValue>({
        value: defaultValue
    })

    useEffect(() => {
        if (Step1?.isSaved === true) {
            setInputValue(
                produce((draft: DataInputValue) => {
                    draft['value'].value = Step1?.value
                })
            );
            setCurrentAccount(Step1?.currentAccount)
        }
    }, [])

    // useEffect(() => {
    //     async function callApiInfo() {
    //         const { isSuccess, data } = await getDataInfoMF(currentAccount)
    //         if (isSuccess) {
    //             const { baldefovd } = data
    //             setAsset(baldefovd)
    //         }
    //     }
    //     callApiInfo()
    // }, [currentAccount])

    useEffect(() => {
        async function callApiCopierInfo() {
            const { isSuccess, data } = await getCopierInfo({ accountId: refaccount, masterAccount: dataMasterTrade?.afacctno })
            if (isSuccess) {
                setValueCopied(data?.[0]?.invest_balance)
                setAsset(data?.[0]?.cur_balance)
            }
        }
        callApiCopierInfo()
    }, [refaccount])

    const handleChangeAccount = (event: SelectChangeEvent) => {
        setCurrentAccount(event.target.value);
    };

    const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: Field) => {
        setInputValue(
            produce((draft: DataInputValue) => {
                draft[key].value = event.target.value
                const result = validByKey(key, event.target.value)
                if (result) {
                    draft[key].isError = result.isError
                    draft[key].contextError = result.contextError
                }
            })
        );
    };

    const validByKey = (key: any, value: any) => {
        const result = {
            key: key,
            isError: false,
            contextError: '',
        }
        if (value === '' || Number.parseFloat(value) === 0) {
            result.isError = true
            result.contextError = t("copytrade.withdraw.notEmpty")
        } else if (Number.parseFloat(value) > asset) {
            result.isError = true
            result.contextError = t("copytrade.withdraw.greater")
        }

        return result
    }

    const validationWhenNext = () => {
        let arrayError = []
        for (const property in inputValue) {
            const result = validByKey(property, inputValue[property as Field].value)
            if (result.isError === true) {
                arrayError.push(result)
            }
        }
        setInputValue(
            produce((draft: DataInputValue) => {
                arrayError.forEach(element => {
                    if (element.isError === true) {
                        draft[element.key as Field].isError = element.isError
                        draft[element.key as Field].contextError = element.contextError
                    }
                });
            })
        );
        console.log('ha_check_arrayError', arrayError)
        return arrayError.length === 0 ? false : true
    }

    const handleNext = async () => {
        const isError = validationWhenNext()

        if (isError) return;

        setStateLoadingAction(true)
        const { isSuccess, data } = await doInit2factorAuth()
        setStateLoadingAction(false)
        if (isSuccess && Object.hasOwn(data, 'transactionId')) {
            handleSaveDataOnParents("Step1", {
                isSaved: true,
                valueCopied,
                value: inputValue.value.value,
                currentAccount
            });
            handleSaveDataOnParents("dataVerify", data);
            next()
        }

    }

    const handleBack = () => {
        back()
    }

    return (
        <Box className="Step1">
            <Stack
                direction={"column"}
                spacing={2}
            >
                <Stack
                    direction={"column"}
                    justifyContent={"space-between"}
                    spacing={2}
                >
                    <Box>
                        {t("copytrade.withdraw.drawAmount")}
                    </Box>
                    <Box>
                        <InputNumber
                            realValue={inputValue.value.value as InputValueNumber}
                            handleChangeInput={(e) => handleChangeInput(e, 'value')}
                            error={inputValue.value.isError}
                            maxValue={999999999999}
                            minValue={0}
                            endAdornment={'VND'}
                            thousandSeparator=','
                        />
                        {/* <TextField
                            className='input-number-hidden-arrow'
                            fullWidth={true}
                            size='small'
                            value={objValueStep1.value}
                            onChange={(e) => handleChangeInput(e, 'value')}
                            sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            id="outlined-basic" variant="outlined"
                            error={objValidStep1.value.isError}
                            type='number'
                        /> */}
                    </Box>
                    {inputValue.value.isError === true &&
                        <FormHelperText error id="value">
                            {inputValue.value.contextError}
                        </FormHelperText>
                    }
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                            {t("copytrade.withdraw.copyValue")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={valueCopied} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                            {t("copytrade.withdraw.available")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='right' value={asset} />
                    </Box>
                </Stack>

                <Stack
                    direction={"column"}
                    spacing={2}
                >
                    <div className="label-custodycd">
                        {t("copytrade.withdraw.linkAccount")} <span className={cx('text-req')}>*</span>
                    </div>

                    <AccountSelector
                        currentAccountId={currentAccount}
                        handleChangeAccount={handleChangeAccount}
                    />
                </Stack>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => close()} >{t("copytrade.common.close")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.next")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step1